import {Component} from '@angular/core';
import {FormControl, FormGroup} from "@angular/forms";
import {DialogRef} from '@progress/kendo-angular-dialog';

@Component({
  selector: 'app-download-dialog',
  templateUrl: './download-dialog.component.html',
  styleUrls: ['./download-dialog.component.scss']
})

export class DownloadDialogComponent {
  formGroup: FormGroup;
  formOptions: FormGroup;
  fileTypes =  [ "CSV", "XML" ];
  options = ["Formatted", "Pipe Delim"];
  checked = [true, true];

  constructor(private dialogRef: DialogRef) {

  }

  ngOnInit() {
    this.buildForm();
  }

  buildForm() {
    let group = {};
    let options = {};
    this.fileTypes.forEach(type => {
      group[type] = new FormControl(true);
    });

    this.options.forEach(option => {
      group[option] = new FormControl(true);
    });

    this.formGroup = new FormGroup(group);
   // this.formOptions = new FormGroup(options);
  }

  onSubmit() {
    console.log('this.formGroup.value--', this.formGroup.value);
    let data = this.formGroup.value;
    let output = {
      ...data
    };
    this.dialogRef.close({text: 'Submit', primary: true, output});
  }

}

